const SpressoProduct = {
    INSTALLMENT_SELECTORS: {
        inline: () => SpressoProduct.INSTALLMENT_SELECTORS.shopifyPaymentTerms()?.shadowRoot?.querySelector('#shopify-installments-content'),
        inlineButton: () => SpressoProduct.INSTALLMENT_SELECTORS.shopifyPaymentTerms()?.shadowRoot?.querySelector('#shopify-installments-cta'),
        modal: () => document.querySelector('[data-nametag="shop-portal-provider"]')?.shadowRoot?.querySelector('p'),
        container: () => document.body,
        shopifyPaymentTerms: () => document.querySelector('shopify-payment-terms')
    },

    /**
     * Execute a function when Spresso is ready, immediately if already so.
     * @param {Function} fn
     */
    onSpressoReady: fn => {
        if (window.Spresso?.spressoReady) {
            fn();
        } else {
            window.addEventListener('SpressoReady', fn);
        }
    },

    /**
     * Execute a function when an element becomes available in a container.
     * @param {Function} containerSelectorFn function to select the container
     * @param {Function} targetSelectorFn function to select the target
     * @param {Function} fn
     */
    onElementAvailable: (containerSelectorFn, targetSelectorFn, fn) => {
        let targetFound = false;

        // callback function to execute when mutations are observed
        const callback = (mutationsList, observer) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const targetEl = targetSelectorFn();
                    if (targetEl) {
                        // target detected, stop observing
                        observer.disconnect();

                        // act on target
                        if (!targetFound) {
                            targetFound = true;
                            fn(targetEl);
                        }
                    }
                }
            }
        };

        // create observer instance
        const observer = new MutationObserver(callback);

        // observe container for mutations
        const containerNode = containerSelectorFn();
        if (containerNode) {
            // fire if already met
            const targetEl = targetSelectorFn();
            if (targetEl) {
                fn(targetEl);
                return;
            }

            // otherwise, observe
            const config = {childList: true, subtree: true};
            observer.observe(containerNode, config);
        }
    },

    /**
     * Execute a function when shopify payment installments section  is ready.
     * @param {Function} fn
     */
    onShopifyPaymentInstallmentsReady: fn => {
        SpressoProduct.onElementAvailable(SpressoProduct.INSTALLMENT_SELECTORS.container,
            SpressoProduct.INSTALLMENT_SELECTORS.inline, fn)
    },

    /**
     * Initialize valid payment installments UX.
     */
    generalizePaymentInstallments: () => {
        try {
            // generalize shop pay installments inline
            const inline = SpressoProduct.INSTALLMENT_SELECTORS.inline();
            if (inline) {
                // update text
                SpressoProduct.maintainPaymentInstallments();
                // ensure re-render with logo
                const shopifyPaymentTerms = SpressoProduct.INSTALLMENT_SELECTORS.shopifyPaymentTerms();
                shopifyPaymentTerms.setAttribute('shopify-meta', shopifyPaymentTerms.getAttribute('shopify-meta'));
            }

            // generalize content when Learn More modal is launched
            const inlineButton = SpressoProduct.INSTALLMENT_SELECTORS.inlineButton();
            if (inlineButton) {
                inlineButton.addEventListener('click', () => {
                    // generalize shop pay installments modal content
                    const modal = SpressoProduct.INSTALLMENT_SELECTORS.modal();
                    if (modal) {
                        if (modal.innerText.toLowerCase().includes('every')) {
                            // standard messaging with price, number of installments
                            modal.innerHTML = 'Select installments at checkout to split your purchase into interest-free payments'
                        } else {
                            // more involved payment plans, compatible with trailing "purchase"
                            modal.innerHTML = 'Select installments at checkout for interest-free payments to split your'
                        }
                    }

                    // remove more involved payment plans, if present
                    SpressoProduct.INSTALLMENT_SELECTORS.modal().parentElement?.querySelector('ul')?.remove();

                    // maintain inline content
                    SpressoProduct.maintainPaymentInstallments();
                });
            }

            // show shop pay installments section
            const mask = document.querySelector('.spresso-mask-payment-terms');
            if (mask) {
                mask.style = '';
                mask.classList.remove('spresso-mask-payment-terms');
            }
        } catch (error) {
        }

    },

    /**
     * Ensure continued validity of payment installments UX.
     */
    maintainPaymentInstallments: () => {
        try {
            const inline = SpressoProduct.INSTALLMENT_SELECTORS.inline();
            if (inline) {
                inline.innerHTML = 'Pay in interest-free installments';
            }
        } catch (error) {}
    }
};